import { isValidPhoneNumber } from 'libphonenumber-js/core';
import metadata from 'libphonenumber-js/metadata.min.json';
import { array, boolean, mixed, object, string } from 'yup';

import {
  ConsultType,
  Gender,
  Honorific,
} from '../../../data/types/api/graphql';
import { isValidBirthDate } from '../../../data/utils/date.utils';
import { messages, regExEmail, trim } from '../../../data/utils/form.utils';
import { FileItemData } from '../../../data/utils/upload.utils';

export const schema = object()
  .shape({
    firstName: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    lastName: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    initials: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    email: string()
      .transform(trim)
      .required(messages.required.id)
      .email(messages.invalidEmail.id)
      .matches(regExEmail, messages.invalidRegEx.id)
      .default(''),
    gender: mixed<Gender>()
      .oneOf(Object.values(Gender))
      .required(messages.required.id),
    birthDate: string()
      .transform(trim)
      .test('max-date', messages.invalidDate.id, value =>
        isValidBirthDate(value ?? '')
      )
      .required(messages.required.id)
      .default('')
      .nullable(),
    phoneNumber: string()
      .transform(trim)
      .test('international-phone', messages.invalidPhone.id, value =>
        value ? isValidPhoneNumber(value, metadata) === true : false
      )
      .required(messages.required.id)
      .default(''),
    avatar: mixed<FileItemData>().default(null).nullable(),
    healthProviderId: string()
      .transform(trim)
      .required(messages.required.id)
      .default(undefined),
    // .nullable(),
    honorific: mixed<Honorific>()
      .oneOf(Object.values(Honorific))
      .required(messages.required.id)
      .default(Honorific.GeneralPractitioner),
    meetingRoomLink: string().transform(trim).default(''),
    consultTypes: array(
      mixed<ConsultType>().oneOf(Object.values(ConsultType))
    ).default([]),
    isAdmin: boolean().nullable().default(false),
  })
  .required()
  .noUnknown();
